// extracted by mini-css-extract-plugin
var _1 = "_7fI1VAeH_89uYwPrPO2g";
var _2 = "MXFYHWxqyboHHLiaY9rO";
var _3 = "ERKfl81wgihz8NcNAhtY";
var _4 = "yA8a5OkRreWnmSysHZTO";
var _5 = "tNobq_V_bWG_LxkCy3sC";
export { _1 as "button", _2 as "controls", _3 as "input", _4 as "uploadGuideTip", _5 as "wrapper" }
